var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "month-days" },
    [
      _c("c-input", {
        attrs: {
          type: "select",
          "floating-label": "Дни месяца",
          "label-full-name": "Дни месяца",
          value: _vm.localValue,
          multiple: true,
          items: _vm.items,
          "remove-selected": true,
          required: _vm.invalid,
          "required-message": _vm.error,
        },
        on: { input: _vm.onInput },
      }),
      _vm.error
        ? _c("error-feedback", { attrs: { text: _vm.error } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }